import React, { useEffect } from "react";
import { Table, Switch, Space, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useGoodsModel } from "../materialModel";
import { IMaterialDetail, IMaterialBasesDetail } from "../materialService";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "../../dict/dictModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys,
        onDisabled
    } = useGoodsModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();


    const columns: ColumnsType<IMaterialDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (text, record, index) => `${index + 1}`
        }, {
            // title: '商品编码',
            title: Locale["Material Code"],
            width: 150,
            dataIndex: 'code',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称',
            title: Locale["Material Name"],
            width: 160,
            dataIndex: 'name',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 160,
            dataIndex: 'nameEn',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '替换编码',
            title: Locale["Manufacturer Code"],
            width: 180,
            dataIndex: 'replaceCode',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '库房',
            title: Locale["Warehouse"],
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale["Shelf"],
            width: 160,
            dataIndex: 'shelfCode',
        }, {
            // title: '单位',
            title: Locale["Unit"],
            width: 160,
            dataIndex: 'unitCode',
            ellipsis: true,
            // render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
            render: (text) => {
                if (text && getTreeNodeOne(text).length != 0) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '进货价',
            title: Locale["Purchase Price"],
            width: 160,
            dataIndex: 'purchasePrice',
        }, {
            // title: '零售价',
            title: Locale["Retail Price"],
            width: 120,
            dataIndex: 'retailPrice',
        }, {
            // title: '商品品牌',
            title: Locale["Material Brand"],
            width: 120,
            dataIndex: 'brandCode',
            ellipsis: true,
            // render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
            render: (text) => {
                if (text && getTreeNodeOne(text).length != 0) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '商品分类',
            title: Locale["Material Type"],
            width: 120,
            dataIndex: 'typeCode',
            ellipsis: true,
            // render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
            render: (text) => {
                if (text && getTreeNodeOne(text).length != 0) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '规格型号',
            title: Locale["Spec&Model"],
            width: 180,
            dataIndex: 'model',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,

        }, {
            // title: '状态',
            title: Locale["Status"],
            width: 160,
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={record.enable === 1} onChange={(checked) => {
                        onDisabled(record.id as string, checked);
                    }} />
                </Space>
            )
        }
    ];
    //点击行选高亮
    const onRow = (id: string) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([id as string]);
        }
    };

    useEffect(() => {
        loadData()
    }, [])

    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                type: "radio",
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: IMaterialDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string)
            })}
            scroll={{ x: 'max-content', y: 520 }}
        />
    )
}
